<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useAiChatStore } from '@/stores/aiChat'
import { useChatStore } from '@/stores/chat'
import { X, Bot, List } from 'lucide-vue-next'
import AiConversationList from './AiConversationList.vue'
import AiConversation from './AiConversation.vue'

const aiStore = useAiChatStore()
const chatStore = useChatStore()
const showMobileSidebar = ref(false)

watch(() => aiStore.isOpen, (open) => {
  if (open) chatStore.isOpen = false
})

onMounted(() => {
  aiStore.fetchConversations()
})
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-all duration-200 ease-out"
      enter-from-class="opacity-0 translate-y-4 scale-95"
      enter-to-class="opacity-100 translate-y-0 scale-100"
      leave-active-class="transition-all duration-150 ease-in"
      leave-from-class="opacity-100 translate-y-0 scale-100"
      leave-to-class="opacity-0 translate-y-4 scale-95"
    >
      <div
        v-if="aiStore.isOpen"
        class="fixed bottom-0 right-0 sm:bottom-24 sm:right-24 z-50 w-full h-full sm:w-[480px] sm:h-[600px] sm:rounded-xl bg-surface-900 border border-surface-700 shadow-2xl flex flex-col overflow-hidden"
      >
        <!-- Panel Header -->
        <div class="flex items-center justify-between px-4 py-3 border-b border-surface-700 bg-surface-800">
          <div class="flex items-center gap-2">
            <button
              @click="showMobileSidebar = !showMobileSidebar"
              class="sm:hidden p-1 text-surface-400 hover:text-surface-200 rounded transition-colors"
            >
              <List class="w-4 h-4" />
            </button>
            <Bot class="w-5 h-5 text-violet-400" />
            <h2 class="text-sm font-semibold text-surface-100">Ask Vigilante</h2>
          </div>
          <button @click="aiStore.toggle()" class="p-1 text-surface-400 hover:text-surface-200 rounded transition-colors">
            <X class="w-4 h-4" />
          </button>
        </div>

        <!-- Body: Sidebar + Conversation -->
        <div class="flex-1 flex overflow-hidden">
          <!-- Left: Conversation list -->
          <div
            class="w-[180px] border-r border-surface-700 overflow-y-auto flex-shrink-0"
            :class="showMobileSidebar ? 'block' : 'hidden sm:block'"
          >
            <AiConversationList />
          </div>

          <!-- Right: Active conversation -->
          <div class="flex-1 flex flex-col overflow-hidden">
            <AiConversation />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
